/**
 * Einstiegspunkt der Weboberfläche.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { SitzungAnbieter } from './sitzung/SitzungKontext';
import './stil/grund.css';

const wurzel = document.getElementById('wurzel');
if (!wurzel) throw new Error('Das Element #wurzel fehlt in index.html');

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <SitzungAnbieter>
        <App />
      </SitzungAnbieter>
    </BrowserRouter>
  </StrictMode>,
);
